<template>
    <v-card tile v-if="stationId">
        <iframe :src="siteMapLink" :width="width" :height="height"></iframe>
    </v-card>
</template>

<script>
export default {
    name: 'SiteMap',
    props: {
        stationId: {
            type: Number
        },
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '100%'
        }
    },
    data() {
        return {};
    },
    computed: {
        siteMapLink() {
            const baseURL =
                'https://s3.amazonaws.com/upt-prod-s3-eleos/SitemapsAndDipcharts/';
            const sitemapLink = `${baseURL}${this.stationId}/Sitemap-${this.stationId}.pdf`;
            return sitemapLink;
        }
    },
    methods: {}
};
</script>
